import { getRequestHeaders, handleRes } from 'utils';
import { PropertyInstruction } from 'types';

interface GetPropertyInstructionsParams {
  tenantID: string | number | undefined;
  propertyID: string | number | undefined;
}
export const getPropertyInstructions = ({
  tenantID,
  propertyID,
}: GetPropertyInstructionsParams): Promise<PropertyInstruction[]> => {
  return fetch(
    `${window.PROPERTY_BASE_URL}/tenant/${tenantID}/properties/${propertyID}/instructions`,
    {
      method: 'GET',
      ...getRequestHeaders(),
    },
  )
    .then((res) => handleRes<PropertyInstruction[]>(res, 200))
    .catch((e) => {
      throw e;
    });
};

interface CreateInstructionParams {
  tenantID: string | number | undefined;
  propertyID: string | number | undefined;
  body: string;
}
export const createInstruction = async ({
  tenantID,
  propertyID,
  body,
}: CreateInstructionParams): Promise<Response> => {
  return await fetch(
    `${window.PROPERTY_BASE_URL}/tenant/${tenantID}/properties/${propertyID}/instructions`,
    {
      method: 'POST',
      ...getRequestHeaders(),
      body,
    },
  );
};

interface UpdateInstructionParams {
  tenantID: string | number | undefined;
  propertyID: string | number | undefined;
  instructionID: number | string | undefined;
  body: string;
}
export const updateInstruction = async ({
  tenantID,
  propertyID,
  instructionID,
  body,
}: UpdateInstructionParams): Promise<Response> => {
  return await fetch(
    `${window.PROPERTY_BASE_URL}/tenant/${tenantID}/properties/${propertyID}/instructions/${instructionID}`,
    {
      method: 'PUT',
      ...getRequestHeaders(),
      body,
    },
  );
};

interface DeleteInstructionParams {
  tenantID: string | number | undefined;
  propertyID: string | number | undefined;
  instructionID: number | string | undefined;
}
export const deleteInstruction = async ({
  tenantID,
  propertyID,
  instructionID,
}: DeleteInstructionParams): Promise<Response> => {
  return await fetch(
    `${window.PROPERTY_BASE_URL}/tenant/${tenantID}/properties/${propertyID}/instructions/${instructionID}`,
    {
      method: 'DELETE',
      ...getRequestHeaders(),
    },
  );
};
